import React, { FC } from 'react';
import cn from 'classnames';
import { Block, MediumBlockGroup as MediumBlockGroupProps } from 'store/landing/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './MediumBlockGroup.module.scss';
import MediumBanner from '../MediumBaner/MediumBanner';
import MediumBlockGroupCarousel from './MediumBlockGroupCarousel/MediumBlockGroupCarousel';

const MediumBlockGroup: FC<MediumBlockGroupProps> = ({ blocks, component, title, variant = 'default', seeAllUrl }) => {
  const { theme } = useLandingPageContext();
  if (component === 'carousel') {
    return <MediumBlockGroupCarousel blocks={blocks} title={title} variant={variant} seeAllUrl={seeAllUrl} />;
  }

  if ((theme === 'studio' && component === 'grid') || theme === 'shopify') {
    return (
      <div className={cn(styles.mediumBlockGroup, styles[`theme-${theme}`])}>
        <div className={styles.grid}>
          {blocks.map((block: Block) => (
            <MediumBanner
              key={block.entryId}
              mode="grid"
              imageUrl={block.imageUrl || ''}
              imageUrlMobile={block.imageUrlMobile || ''}
              referenceBackgroundColor={block.referenceBackgroundColor || ''}
              referenceBorderColor={block.referenceBorderColor || ''}
              referenceLabel={block.referenceLabel || ''}
              referenceLabelColor={block.referenceLabelColor || ''}
              referenceUrl={block.referenceUrl || ''}
              discountBubble={block.discount}
              title={block.title}
              subtitle={block.subtitle}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mediumList}>
      {blocks.map((block: Block) => (
        <MediumBanner
          key={block.entryId}
          mode="grid"
          imageUrl={block.imageUrl || ''}
          imageUrlMobile={block.imageUrlMobile || ''}
          referenceBackgroundColor={block.referenceBackgroundColor || '#27aaea'}
          referenceBorderColor={block.referenceBorderColor || '#27aaea'}
          referenceLabel={block.referenceLabel || ''}
          referenceLabelColor={block.referenceLabelColor || '#ffffff'}
          referenceUrl={block.referenceUrl || ''}
          discountBubble={block.discount}
        />
      ))}
    </div>
  );
};

export default MediumBlockGroup;
